import * as TYPES from '../types';

export const userSignInAction = (payload) => {
    return {
        type: TYPES.SIGN_IN,
        payload: payload
    };
};

export const userSignInSuccessAction = payload => {
    return {
        type: TYPES.SIGN_IN_SUCCESS,
        payload: payload,
    };
};
